/**
 * 指定したIDのテキストエリアの内容をクリップボードにコピーします。
 *
 * 使い方1: ボタンをクリックしたときにコピー
 * ```
 * <textarea id="textarea1">コピーしたいテキスト</textarea>
 * <button type="button" data-mtapp-copy-target-id="textarea1" onclick="copyToClipboard(this)">コピー</button>
 * ```
 *
 * 使い方2: addEventListenerでクリックイベントを登録
 * ```
 * <textarea id="textarea1">コピーしたいテキスト</textarea>
 * <button type="button" data-mtapp-copy-target-id="textarea1">コピー</button>
 * <script>
 *     const targets = document.querySelectorAll('[data-mtapp-copy-target-id]');
 *     targets.forEach((target) => {
 *         target.addEventListener('click', (event) => {
 *             event.preventDefault();
 *             copyToClipboard(event.target);
 *          });
 *     });
 * </script>
 * ```
 *
 * @param {HTMLElement} element - クリックされたボタン要素
 * @returns {void}
 */
export function copyToClipboard(element) {
    // Get the target element from the data-mtapp-copy-target-id attribute
    const targetId = element.getAttribute('data-mtapp-copy-target-id');
    const targetElement = document.getElementById(targetId);

    // Check if the target element exists and is a textarea
    if (targetElement && targetElement.tagName.toLowerCase() === 'textarea') {
        // Select the content of the textarea
        targetElement.select();

        // Copy the selected content to the clipboard
        document.execCommand('copy');

        // Display a message
        displayFadeMessage(event.target, 'コピーしました');
    } else {
        console.error(`Element with ID "${targetId}" not found or is not a textarea.`);
    }
}

/**
 * Displays a fading message above a reference element.
 *
 * @param {HTMLElement} refElement - The reference HTML element above which the message will be displayed.
 * @param {string} message - The message to be displayed.
 */
function displayFadeMessage(refElement, message) {
    const msgElement = document.createElement('span');

    // Apply the styles directly to the element
    Object.assign(msgElement.style, {
        display: 'inline-block',
        padding: '5px 10px',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        color: 'white',
        borderRadius: '5px',
        position: 'absolute',
        transform: 'translate(0, -110%)',
        transition: 'opacity 1s ease',
        opacity: '0'
    });
    msgElement.innerText = message;

    // Insert the message just before the reference element
    refElement.parentNode.insertBefore(msgElement, refElement);

    // Force reflow to enable the transition
    void msgElement.offsetWidth;

    // Set opacity to 1 for the fade-in effect
    msgElement.style.opacity = '1';

    // Fade out and remove the message after 2 seconds
    setTimeout(() => {
        msgElement.style.opacity = '0';
        setTimeout(() => {
            msgElement.remove();
        }, 1000);
    }, 2000);
}
